// extracted by mini-css-extract-plugin
export default {"orderReference":"styles_orderReference__Q3NvI","orderTime":"styles_orderTime__4AJxj","orderItem":"styles_orderItem__w9-nW"};